export const CONSTRAINTS = {
  name: {
    presence: { allowEmpty: false, message: 'is required' },
    length: { minimum: 3, message: 'must be at least 3 characters' },
  },
};

export const DEBOUNCE_DELAY = 1000;
